import axios from '@/axios.js'

const state = () => ({
    pajaks: []
})

const mutations = {
    SET_PAJAKS (state, payload) {
      state.pajaks = payload
    },
    ADD_PAJAK (state, item) {
      state.pajaks.unshift(item)
    },
    UPDATE_PAJAK (state, pajak) {
      const pajakIndex = state.pajaks.findIndex((p) => p.id === pajak.id)
      Object.assign(state.pajaks[pajakIndex], pajak)
    },
    REMOVE_PAJAK (state, itemId) {
      const ItemIndex = state.pajaks.findIndex((p) => p.id === itemId)
      state.pajaks.splice(ItemIndex, 1)
    },
}

const actions = {
  fetchPajak ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list/pajak`)
        .then((response) => {
          commit('SET_PAJAKS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addPajak ({ commit }, pajak ) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', pajak)
        .then((response) => {
          commit('ADD_PAJAK', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updatePajak ({ commit }, pajak) {
    return new Promise((resolve, reject) => {
      axios.post(`/term-update/${pajak.id}`, pajak)
        .then((response) => {
            commit('UPDATE_PAJAK', response.data.data)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removePajak ({ commit }, pajak) {
    return new Promise((resolve, reject) => {
      axios.delete(`/term-delete/${pajak.id}`)
        .then((response) => {
            commit('REMOVE_PAJAK', pajak.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}